import { TextArea as TextAreaComponent, TextAreaProps } from 'ui/TextArea';
import { FC, ChangeEvent, CSSProperties } from 'react';
import { styles } from './styles';
import { Box } from 'ui/Box';
import { SxProps, Typography } from '@mui/material';

export type CustomTextAreaProps = TextAreaProps & {
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  sx?: SxProps;
};

export const TextArea: FC<CustomTextAreaProps> = ({
  placeholder,
  onChange,
  error,
  helperText,
  sx,
  ...rest
}) => {
  return (
    <Box sx={{ ...styles.root, ...sx } as SxProps}>
      <Box
        component={'textarea'}
        sx={{ ...styles.textarea, ...(error ? styles.error : {}) } as SxProps}
        placeholder={placeholder}
        onChange={onChange}
        {...rest}
      />
      {error && (
        <Typography variant="caption" sx={styles.errorText}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};
